import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import Modal from 'react-modal';
import { validateFloat } from "../../helpers/common";
import CustomScrollMenu from "../customScrollMenu"




const Benefit = ({ getBenefitsDetails, updateBenefitList, selectedBenefits, editMode, removeBenefits, benefits }) => {
    const navigate = useNavigate();
    const params = useParams();
    const [isBtn, setIsBtn] = useState(false);
    const [benefit, setBenefit] = useState(null);
    const [benefitTags, setBenefitTags] = useState(null);
    const [tags, setTags] = useState(null);
    const [currentTag, setCurrentTag] = useState(null);
    const [addBenefitModalOpen, setAddBenefitModalOpen] = useState(null);
    const Arrow = ({ text, className }) => {
        return (<div className={className}  >{text}</div>);
    };

    const ArrowLeft = Arrow({ text: '<<', className: 'arrow-prev' });
    const ArrowRight = Arrow({ text: '>>', className: 'arrow-next' });


    useEffect(() => {

        window.scrollTo(0, 0)

        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }

        getBenefitTags();


    }, []);


    const getBenefitTags = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-benefit-tags/", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {



                const tags = response.data?.benefit_tags?.map(el => {
                    const { tag_title, benefit_tag_id } = el;

                    return (<div className={`btn btn-grey`} key={benefit_tag_id}  >{tag_title}</div>)
                });

                setBenefitTags(tags);
                setTags(response.data?.benefit_tags);


            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Request Benefit Tags Not Found", text: error.message });

            });
    }


    const saveBenefit = async (e) => {
        e.preventDefault();
        setIsBtn(true);

        if (!benefit?.benefit_amount || !benefit.benefit_tag_id) {
            Swal.fire({ icon: "error", title: "Error", text: "All fields are required." });
            setIsBtn(false)
        }
        else if (!validateFloat(benefit?.benefit_amount)) {
            Swal.fire({ icon: "error", title: "Error", text: "Enter a numeric benefit Value." });
            setIsBtn(false)

        }
        else {

            await axios.post(process.env.REACT_APP_API_URL + "/save-benefit", {
                benefit_amount: benefit.benefit_amount,
                benefit_tag_id: benefit.benefit_tag_id

            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {
                        setAddBenefitModalOpen(false);
                        getBenefitsDetails();
                        updateBenefitList();

                    }
                    else {
                        Swal.fire({ icon: "error", title: "Error", text: response?.data?.message });
                    }

                    setIsBtn(false)
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };



    return (
        <>
        {editMode ? 
        <>
           {selectedBenefits?.length>0 && <button onClick={() => {  removeBenefits(1)  }} className="btn btn-lg btn-under bg-none">Remove ({selectedBenefits?.length})</button> }
            <button onClick={() => { removeBenefits() }} className="btn btn-lg  btn-under">Remove All</button>

            </>
            :
            <>
             { (!benefits || benefits?.length < 5) &&
          
            <button onClick={() => { setBenefit(null); setAddBenefitModalOpen(true) }} className="btn btn-secondary list-button-add color-white flex-grow-1">

                <label>Add</label>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                        <path d="M8.75 9.75V14.25H10.25V9.75H14.75V8.25H10.25V3.75H8.75V8.25H4.25V9.75H8.75Z" fill="white" />
                    </svg>
                </span>
            </button>
}
</>
        }

            <Modal
                isOpen={addBenefitModalOpen}
                onRequestClose={() => { setAddBenefitModalOpen(false) }}
                contentLabel="Add Benefit"
                className="modal"
                overlayClassName="overlay"
            >
                <div className="modal-title" >

                    <div className="flex-equal justify-content-start " ></div>
                    <h3 className="flex-equal justify-content-center fs-18 fs-helvetica  color-white">Add Benefit</h3>
                    <div className="flex-equal justify-content-end" >
                        <div className="icon" onClick={() => setAddBenefitModalOpen(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M8.0312 7L10.8154 9.78423L9.78423 10.8154L7 8.0312L4.21577 10.8154L3.18457 9.78423L5.9688 7L3.18457 4.21577L4.21577 3.18457L7 5.9688L9.78424 3.18457L10.8154 4.21577L8.0312 7Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                </div>
                <form onSubmit={saveBenefit} action="#"  >

                <div className="modal-body min-height" >
                    <div className="box modal" >
                        <div className="form-content" >
                            <div className="input-container" >
                               <input type="text" className="transparent-input" id="benefit" placeholder="$0"
                                    name="benefit_amount" value={benefit?.benefit_amount > 0 ? "$" + benefit?.benefit_amount : ""}
                                    onChange={(e) => setBenefit({ ...benefit, benefit_amount: e.target.value?.replace("$", "") })}
                                />
                            </div>
                            {benefit?.benefit_tag_id > 0 &&
                                <div className="input-container align-items-center" >

                                    <button className="btn btn-primary" >{currentTag["tag_title"]}</button>

                                </div>
                            }

                        </div>




                    </div>
                 
                    <div className="px-2 horizontal-bottom-menu" >

 <CustomScrollMenu
    items={tags}
    selectedId={benefit?.benefit_tag_id}
    id="benefit_tag_id"
    onSelect={(key) => {
        setBenefit({ ...benefit, benefit_tag_id: key });
        const t = tags?.find((o) => o.benefit_tag_id === key);
        setCurrentTag(t);
    }}
/>

                       
                    </div>

                    </div>
                    <div className="modal-footer  justify-content-space-between" >
                        <button className="btn btn-secondary" type="button" onClick={() => { setAddBenefitModalOpen(false) }}>Cancel</button>
                        <button className=" btn btn-primary" type="submit" disabled={isBtn || !benefit?.benefit_amount || !benefit.benefit_tag_id}>
                            {isBtn ? <Loading size={'20px'} /> : 'Save'}</button>


                    </div>

                </form>
            </Modal>

        </>
    );
};

export default Benefit;